'use client';

import { Shimmer } from '@/_components';
import { type FC } from 'react';
import type { TableLoadingProps } from './TableLoading.types';
import styles from './TableLoading.module.css';

const COLUMN_COUNT: number = 6;

export const TableLoading: FC<TableLoadingProps> = () => {
  const loadingRows: Array<number> = [0, 1, 2];

  return (
    <div className={styles.tableLoading}>
      <table className="sorabanTable">
        <thead>
          <tr>
            {Array.from({ length: COLUMN_COUNT })?.map((_column, key) => (
              <th key={key} style={{ paddingInline: '8px' }}>
                <Shimmer height={12} width={48} isRounded={true} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loadingRows.map((_row, rowKey) => {
            return (
              <tr key={rowKey}>
                {[...Array(COLUMN_COUNT).keys()]?.map((_, key) => (
                  <td key={key} style={{ paddingRight: '16px' }}>
                    <Shimmer
                      height={16}
                      width={100}
                      isRounded={true}
                      isFullWidth={true}
                    />
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
